import { render, staticRenderFns } from "./EnrollNew.vue?vue&type=template&id=2bdba820&scoped=true"
import script from "./EnrollNew.vue?vue&type=script&lang=js"
export * from "./EnrollNew.vue?vue&type=script&lang=js"
import style0 from "./EnrollNew.vue?vue&type=style&index=0&id=2bdba820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdba820",
  null
  
)

export default component.exports